import * as THREE from 'three'
import Scene from '../index.js'

class Trail 
{
    constructor(obj)
    {
        this.canvas = document.createElement('canvas')
        this.context = this.canvas.getContext('2d')
        this.ratio = obj.ratio
        this.canvas.width = 500
        this.canvas.height = this.canvas.width / this.ratio
        this.points = []
        this.maxAge = 30
        this.radius = 5
        this.raycaster = Scene.raycaster
        this.mouse = Scene.mouse
        this.isVisible = false;

        this.initCanvas()

        this.raycaster.on('intersect', () => 
        {   
            this.storePoints(this.raycaster.intersect)
        })
    }

    initCanvas()
    {
	    this.context.fillStyle = 'black'
		this.context.fillRect(0, 0, this.canvas.width, this.canvas.height);
        
        if(this.isVisible)
        {
            document.body.appendChild(this.canvas)
            this.canvas.style.position = 'fixed'
            this.canvas.style.zIndex = 100
        } 

        this.texture = new THREE.Texture(this.canvas);
    }

    storePoints(lastpoint)
    {

        let point = {
            x: (lastpoint.x + 0.5) * this.canvas.width,
            y: this.canvas.height - ((lastpoint.y + ((1 / this.ratio) * 0.5)) * this.canvas.height * this.ratio),
            age: 0
        }
        this.points.push(point)
    }   
    
    draw()
    {
        this.clear()

        for(let point of this.points)
        {
            let strength = 1 - (point.age / this.maxAge)
            let r = this.radius * 4 * strength
            this.context.beginPath()

            const gradient = this.context.createRadialGradient(point.x, point.y, r, point.x, point.y, r * 0.1)
            gradient.addColorStop(1, `rgba(255, 255, 255, 1)`)
            gradient.addColorStop(0, `rgba(0, 0, 0, 0)`)
            
            this.context.fillStyle = gradient
            this.context.arc(point.x, point.y, r, 0, 2* Math.PI, false);
            this.context.fill();
        }
    }

    
	clear() 
    {
		this.context.fillStyle = 'black';
		this.context.fillRect(0, 0, this.canvas.width, this.canvas.height);
	}

    update()
    {
        if(this.points.length > 0)
        {
            for(let point of this.points)
            {
                point.age ++ 
    
                if(point.age > this.maxAge)
                {
                    let index = this.points.indexOf(point)
                    this.points.splice(index, 1)
                }
            }

            this.draw()

            this.texture.needsUpdate = true
        }
    }
}

export default Trail